import { Membership } from "types";
import { isOrganizerSelected } from "../../../models/Guest";
import { CreatePurchaseItemState, useCreatePurchaseStore } from "../../../stores/createPurchaseStore";
import { hasSomeEmptyNameField, hasSomeEmptyRequiredFields } from "../helpers/PurchaseCreateValidationHelpers";
import { hasOrganizerOnlyQuestions } from "@/models/Form/Form";

export const getMembershipValidations = () => {
    const membership = useCreatePurchaseStore.getState().getActiveProduct<Membership>();
    const item = useCreatePurchaseStore.getState().getActiveItem();

    const getDisabledReasons = () => {
        if (!membership) {
            return [];
        }

        return getMembershipItemDisabledReasons(item);
    };

    return { getDisabledReasons };
};

export const getMembershipItemDisabledReasons = (item: CreatePurchaseItemState) => {
    const messages = [];

    if (hasSomeEmptyNameField(item)) {
        messages.push("Please enter all the Member names");
    }

    const form = useCreatePurchaseStore.getState().getForm();

    if (form && hasSomeEmptyRequiredFields(item) && !item.disableRequiredFormFields) {
        messages.push('Please complete the Guest Info questionnaire or toggle on "Ignore questionnaire validation"');
    }

    // Main Guest validation is shown when there are more than 1 guests and there are organizer questions in questionnaire
    if ((item.guests?.length ?? 1) > 1 && hasOrganizerOnlyQuestions(form) && !isOrganizerSelected(item.guests)) {
        messages.push("Please select the main guest from the guest info section");
    }

    return messages;
};
